import { STRINGS } from '@tm/shared'
import { mountSandboxIframe, destroySandbox } from '../sandbox/host.js'

export function createPlayMode({ onEdit }) {
  const el = document.createElement('section')
  el.className = 'tm-mode tm-play'
  el.setAttribute('role', 'tabpanel')
  el.setAttribute('aria-label', STRINGS.modePlay)
  el.innerHTML = `
    <div class="tm-play__header">
      <button type="button" class="tm-btn-secondary tm-play__back" data-action="edit">
        ← ${STRINGS.actionEdit}
      </button>
      <h2 class="tm-play__title">${STRINGS.playTitle}</h2>
    </div>
    <div class="tm-play__stage" data-role="stage">
      <div class="tm-play__loading" data-role="loading" aria-live="polite">
        <div class="tm-spinner" aria-hidden="true"></div>
        <p>${STRINGS.playLoading}</p>
      </div>
    </div>
  `

  const stage = el.querySelector('[data-role="stage"]')
  const loading = el.querySelector('[data-role="loading"]')
  const backBtn = el.querySelector('[data-action="edit"]')

  backBtn.addEventListener('click', () => {
    destroySandbox()
    onEdit?.()
  })

  // Observer HARUS dipasang SEBELUM mountSandboxIframe, karena
  // MutationObserver tidak fire untuk mutasi yang sudah terjadi sebelum observe()
  // dipasang. Sebelumnya observer dipasang setelah → loading stuck "Menyiapkan game...".
  const observer = new MutationObserver(() => {
    if (stage.querySelector('.tm-sandbox-iframe')) {
      setTimeout(() => {
        loading.style.display = 'none'
      }, 800)
      observer.disconnect()
    }
  })
  observer.observe(stage, { childList: true })

  mountSandboxIframe(stage)

  const originalRemove = el.remove.bind(el)
  el.remove = function () {
    observer.disconnect()
    destroySandbox()
    originalRemove()
  }

  return el
}
